// extracted by mini-css-extract-plugin
module.exports = {"card":"maincard_card__1mJTY","tabpaneMainCard":"maincard_tabpaneMainCard__28h82","mainCardTab":"maincard_mainCardTab__ykwKw"};